import React from "react"

import classNames from "classnames"

import { getUserColor } from "shared/lib/user/getUserColor"
import { getUserInitials } from "shared/lib/user/getUserInitials"
import { UserInfo } from "shared/types/UserInfo"
import { NeoletterUserProfile } from "shared/types/__generated__/graphql"
import { Skeleton } from "shared/ui/skeleton/Skeleton"
import { TextAvatar } from "shared/ui/text-avatar/TextAvatar"

import "./styles/_user-details.scss"

interface UserDetailsModel {
  userInfo?: NeoletterUserProfile | UserInfo | null
  isLoading?: boolean
}

export const UserDetails = React.memo(
  ({ userInfo, isLoading }: UserDetailsModel) => {
    if (!userInfo && !isLoading) {
      return null
    }

    const hasName = Boolean(
      userInfo?.name && userInfo?.name !== userInfo?.email
    )

    return (
      <div
        className={classNames("user-details", {
          "user-details--loading": isLoading
        })}
        data-user-email={userInfo?.email ?? undefined}
      >
        <div className="user-details__avatar">
          <TextAvatar
            initials={getUserInitials({
              name: userInfo?.name,
              email: userInfo?.email || ""
            })}
            color={getUserColor(userInfo?.name || userInfo?.email)}
          />
        </div>

        {isLoading || hasName ? (
          <h6 className="user-details__name">
            {isLoading ? <Skeleton /> : userInfo?.name}
          </h6>
        ) : null}
        <div className="user-details__company">
          {isLoading ? (
            <Skeleton />
          ) : (
            <span className="company">
              {(userInfo as NeoletterUserProfile)?.company || ""}
            </span>
          )}
        </div>
      </div>
    )
  }
)
